module.exports = __webpack_public_path__ + "img/14.ab2cc711.svg";